import TextWithIcon from '../components/typography/TextWithIcon';
import { robotPictures } from '../utilities';
import styles from './UserOfflineSignIn.module.scss';

const image = robotPictures.read;

export default function UserOfflineSignIn() {
  return (
    <div className={styles.container}>
      <TextWithIcon
        size="xl"
        icon="wifi_off"
        noMargin
        noSelect
        textAlign="center"
      >
        Connect to Sign In
      </TextWithIcon>
      <TextWithIcon textAlign="center " noMargin>
        An internet connection is needed to sign in and restore access.
      </TextWithIcon>
      <div>
        <img className={styles.image} src={image} alt="graphic" />
      </div>
    </div>
  );
}
